import { render, staticRenderFns } from "./HolidayList.vue?vue&type=template&id=0d09dc84"
import script from "./HolidayList.js?vue&type=script&lang=js&external"
export * from "./HolidayList.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports